export const inital_data = {
  labels: [],
  datasets: [
    {
      label: 'humidity',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(42, 150, 220)',
      borderColor: 'rgba(42, 150, 220, 0.5)',
      unitPrefix: ' % RH'
    },
    {
      label: 'temp',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(250, 48, 20)',
      borderColor: 'rgba(250, 48, 20, 0.5)',
      unitPrefix: ' °C'
    },
    {
      label: 'co2',
      yAxisID: 'high',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(143,143,143)',
      borderColor: 'rgba(143,143,143, 0.5)',
      unitPrefix: ' ppm'
    },
    {
      label: 'vpd',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(94, 10, 255)',
      borderColor: 'rgba(94, 10, 255, 0.5)',
      unitPrefix: ' hPa'
    },
    {
      label: 'temp_leaf_current',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(149, 193, 30)',
      borderColor: 'rgba(149, 193, 30, 0.5)',
      unitPrefix: ' °C'
    },
    {
      label: 'vol_water_content',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(0, 128, 128)',
      borderColor: 'rgba(0, 128, 128, 0.5)',
      unitPrefix: ' %'
    },
    {
      label: 'ec_root_zone',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(255, 255, 0)',
      borderColor: 'rgba(255, 255, 0, 0.5)',
      unitPrefix: ' mS/cm x10'
    },
    {
      label: 'vol_water_content_2',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(0, 200, 255)',
      borderColor: 'rgba(0, 200, 255, 0.85)',
      unitPrefix: ' %'
    },
    {
      label: 'ec_root_zone_2',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(255, 180, 0)',
      borderColor: 'rgba(255, 180, 0, 0.85)',
      unitPrefix: ' mS/cm x10'
    },
    {
      label: 'vol_water_content_3',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(0, 175, 110)',
      borderColor: 'rgba(0, 175, 110, 0.85)',
      unitPrefix: ' %'
    },
    {
      label: 'ec_root_zone_3',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(255, 110, 0)',
      borderColor: 'rgba(255, 110, 0, 0.85)',
      unitPrefix: ' mS/cm x10'
    },
    {
      label: 'vol_water_content_4',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(0, 240, 190)',
      borderColor: 'rgba(0, 240, 190, 0.85)',
      unitPrefix: ' %'
    },
    {
      label: 'ec_root_zone_4',
      data: [],
      hidden: false,
      tension: 0.5,
      fill: false,
      backgroundColor: 'rgb(200, 255, 0)',
      borderColor: 'rgba(200, 255, 0, 0.85)',
      unitPrefix: ' mS/cm x10'
    }
  ]
};

export const resolution_mapping = {
  4: { name: 'history_type_recent', req: 'get_recent_history' },
  5: { name: 'history_type_recent', req: 'get_recent_history' },
  240: { name: 'history_type_daily', req: 'get_daily_history' },
  900: { name: 'history_type_full', req: 'get_history' }
};
